import { Injectable } from '@angular/core';
import { CrossSellingModel } from '@libs/shop/models';
import { ConnectorService } from '@libs/shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrossSellingRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public getAll(): Observable<CrossSellingModel> {
    return this.connector.connect('shop', 'crossSelling');
  }
}
